// extracted by mini-css-extract-plugin
module.exports = {"SocialShare__group":"InsightShare_SocialShare__group__3dx1j","SocialShare__group__center":"InsightShare_SocialShare__group__center__ySNMK","icon":"InsightShare_icon__eGtnd"};